<script>
  import { format } from 'svelte-i18n';
  import { Column, Input, Spinner, Table } from '@sveltestrap/sveltestrap';

  import { SearchFilter } from '@client/components/filters/search';

  import { BizCardsService } from '@client/services/bizcards';

  /** @type {string | null} */
  export let bizcard = null;

  /** @type {Array<{ email: string }>} */
  export let selectedUsers = [];

  let users = [];
  let loading = false;

  /** @type {Set<string>} */
  let checked = new Set();

  /** @type {string} */
  let search;

  /** @type {string | null} */
  let loadedBizcard = null;

  $: if (bizcard && bizcard !== loadedBizcard) {
    loadUsers(bizcard);
  }

  const loadUsers = async (name) => {
    loading = true;
    loadedBizcard = name;

    const response = await BizCardsService.getUsersByBizcard(name);
    users = response?.data?.data || response?.data || [];

    checked = new Set(users.map((u) => u.email).filter(Boolean));
    selectedUsers = users.filter((u) => checked.has(u.email));

    loading = false;
  };

  /** @param {string} email */
  const toggle = (email) => {
    checked.has(email) ? checked.delete(email) : checked.add(email);
    checked = checked;
    selectedUsers = users.filter((u) => checked.has(u.email));
  };

  const toggleAll = () => {
    if (allChecked) {
      for (const u of filteredUsers) {
        checked.delete(u.email);
      }
    } else {
      for (const u of filteredUsers) {
        checked.add(u.email);
      }
    }
    checked = checked;
    selectedUsers = users.filter((u) => checked.has(u.email));
  };

  $: filteredUsers =
    search?.length > 1
      ? users.filter((row) =>
          Object.values(row).some(
            (value) => typeof value === 'string' && value.toLowerCase().includes(search.toLowerCase())
          )
        )
      : users;

  $: allChecked = filteredUsers.length > 0 && filteredUsers.every((u) => checked.has(u.email));
</script>

{#if loading}
  <div class="text-center p-4">
    <Spinner color="primary" />
  </div>
{:else if users.length}
  <div class="mb-2 d-flex align-items-center">
    <SearchFilter bind:search />
    <small class="text-muted ms-auto">
      {$format('label.BIZCARD.ASSIGN.SELECTED_COUNT', { values: { checked: checked.size, total: users.length } })}
    </small>
  </div>
  <div class="scrollable">
    <Table rows={filteredUsers} size="sm" let:row>
      <Column width="2.5rem">
        <div slot="header">
          <Input type="checkbox" checked={allChecked} class="m-0" on:change={toggleAll} />
        </div>
        <Input type="checkbox" checked={checked.has(row.email)} class="m-0" on:change={() => toggle(row.email)} />
      </Column>
      <Column header={$format('label.USERNAME')}>
        <a role="button" on:click={() => toggle(row.email)}>{row.email}</a>
      </Column>
    </Table>
  </div>
{:else}
  <p class="text-muted">{$format('label.NO_RESULTS')}</p>
{/if}

<style>
  .scrollable {
    max-height: 40vh;
    overflow-y: auto;
  }
</style>
